import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInterfaces = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			opacity: .3,
			d: "M5.50241 17.6086C5.09691 17.3306 5.09691 16.7321 5.50241 16.454L11.5476 12.3087C11.8202 12.1217 12.1798 12.1217 12.4524 12.3087L18.4976 16.454C18.9031 16.7321 18.9031 17.3306 18.4976 17.6086L12.4524 21.754C12.1798 21.9409 11.8202 21.9409 11.5476 21.754L5.50241 17.6086Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .4,
			d: "M4.35397 14.0959C3.94847 13.8178 3.94847 13.2193 4.35397 12.9412L11.5476 8.00835C11.8203 7.82139 12.1798 7.82139 12.4525 8.00835L19.6461 12.9412C20.0516 13.2193 20.0516 13.8178 19.6461 14.0959L12.4525 19.0288C12.1798 19.2157 11.8203 19.2157 11.5476 19.0288L4.35397 14.0959Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.72616 9.55071C2.32066 9.27265 2.32066 8.67416 2.72616 8.3961L11.5476 2.34699C11.8202 2.16003 12.1798 2.16003 12.4524 2.34699L21.2738 8.3961C21.6793 8.67416 21.6793 9.27265 21.2738 9.55071L12.4524 15.5998C12.1798 15.7868 11.8202 15.7868 11.5476 15.5998L2.72616 9.55071Z",
			fill: "currentColor"
		})
	]
});
const ForwardRef = forwardRef(SvgInterfaces);
export { ForwardRef as ReactComponent };
